var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DateInput_fangShape DateInput_fangShape_1",
    d: "M0,10 20,10 10,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DateInput_fangStroke DateInput_fangStroke_1",
    d: "M0,10 10,0 20,10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowleft);
export default __webpack_public_path__ + "static/media/Iconarrowleft.657a340a.svg";
export { ForwardRef as ReactComponent };